// IDs das perguntas do tenant Biofix. Pai = "Abertura da OS (Nomeação)", filha = "Lineup".
export const QUESTIONS = {
  ship: 68, // pai
  destination: 130, // pai
  mapaPort: 167, // pai
  goods: 169, // pai
  quantity: 170, // pai
  exporter: 172, // pai (dentro do bloco 171)
  lpco: 173, // pai (dentro do bloco 171)
  exposureTime: 179, // pai
  terminal: 190, // filha
  berth: 191, // filha
  communicationNumber: 195, // filha
  product: 1005, // filha (dentro do bloco 296)
  dateTime: 302, // filha
  // uma pergunta de dosagem para cada porão
  dosages: [199, 211, 222, 233, 244, 254, 265, 276, 287]
}

const ADDRESS_FIELD_NAME = 'Endereço'
// Campos adicionais do cadastro do local, na ordem em que aparecem no documento
const PLACE_FIELDS = [
  { name: ADDRESS_FIELD_NAME },
  { name: 'CNPJ', label: 'Cnpj' },
  { name: 'Telefone', label: 'Telefone' },
  { name: 'E-mail', label: 'Email' }
]
export const SEPARATOR = ' / '

export const unique = list => [...new Set(list)]
export const pad = number => String(number).padStart(2, '0')

export const toText = value => {
  if (value === null || value === undefined) return ''
  if (Array.isArray(value)) return value.map(toText).filter(Boolean).join(', ')
  if (typeof value === 'object') return toText(value.name)
  return String(value).trim()
}

export const fieldText = value => (typeof value === 'object' && value !== null ? value.search : value) || ''

const formatQuantity = value => {
  const number = Number(value)
  return value === '' || Number.isNaN(number) ? value : number.toFixed(2).replace('.', ',')
}

// "1,0" -> "1"; "2,5" continua "2,5"
export const formatDosage = value => value.replace(/,0+$/, '')

export const findFieldValue = (fieldValues, name) => (fieldValues || []).find(fv => fv.field?.name === name)?.value

export const getAssetIds = replies =>
  [QUESTIONS.terminal, QUESTIONS.berth]
    .map(questionId => replies.find(reply => reply.questionId === questionId)?.value?.id)
    .filter(Boolean)

// Leitura das respostas da atividade pai e de todas as filhas, sempre por ID de pergunta
export const createReader = ({ serviceOrder, childrenServiceOrders = [], assets = [] }) => {
  const replies = [serviceOrder, ...childrenServiceOrders].flatMap(so => so.replies || [])

  const answers = (...questionIds) =>
    replies
      .filter(reply => questionIds.includes(reply.questionId))
      .sort((a, b) => (a.blockIndex ?? -1) - (b.blockIndex ?? -1))
      .map(reply => toText(reply.value))
      .filter(Boolean)
  const answer = questionId => answers(questionId)[0] || ''
  const joined = (...questionIds) => unique(answers(...questionIds)).join(SEPARATOR)

  const assetByQuestion = questionId => {
    const id = replies.find(reply => reply.questionId === questionId)?.value?.id
    return assets.find(asset => asset.id === id)
  }
  const berthAddress = fieldText(findFieldValue(assetByQuestion(QUESTIONS.berth)?.fieldValues, ADDRESS_FIELD_NAME))
  const terminalAddress = fieldText(
    findFieldValue(assetByQuestion(QUESTIONS.terminal)?.fieldValues, ADDRESS_FIELD_NAME)
  )

  return {
    answers,
    answer,
    joined,
    treatmentPlace: [answer(QUESTIONS.terminal), answer(QUESTIONS.berth)].filter(Boolean).join(' ').toUpperCase(),
    treatmentAddress: berthAddress || terminalAddress
  }
}

export const buildDocumentData = ({ serviceOrder, childrenServiceOrders = [], assets = [], now = new Date() }) => {
  const { answers, answer, joined, treatmentPlace, treatmentAddress } = createReader({
    serviceOrder,
    childrenServiceOrders,
    assets
  })

  const scheduledAt = new Date(answer(QUESTIONS.dateTime))
  const hasDate = !Number.isNaN(scheduledAt.getTime())
  const exposureTime = answer(QUESTIONS.exposureTime)

  return {
    activityCode: serviceOrder.yearlyId || '',
    communicationNumber: answer(QUESTIONS.communicationNumber),
    interested: serviceOrder.place?.name || '',
    interestedDetails: PLACE_FIELDS.map(({ name, label }) => {
      const value = fieldText(findFieldValue(serviceOrder.place?.fieldValues, name))
      return value && [label, value].filter(Boolean).join(' ')
    })
      .filter(Boolean)
      .join(' '),
    goods: answer(QUESTIONS.goods).toUpperCase(),
    ship: answer(QUESTIONS.ship).toUpperCase(),
    quantity: formatQuantity(answer(QUESTIONS.quantity)),
    treatmentPlace,
    treatmentAddress,
    date: hasDate
      ? `${scheduledAt.getDate()}/${scheduledAt.getMonth() + 1}/${String(scheduledAt.getFullYear()).slice(-2)}`
      : '',
    time: hasDate ? `${pad(scheduledAt.getHours())}:${pad(scheduledAt.getMinutes())}` : '',
    exposureTime,
    product: joined(QUESTIONS.product),
    dosage: unique(answers(...QUESTIONS.dosages).map(formatDosage)).join(SEPARATOR),
    generatedAt: `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()}`,
    mapaPort: answer(QUESTIONS.mapaPort),
    destination: answer(QUESTIONS.destination),
    lpco: joined(QUESTIONS.lpco),
    exporters: joined(QUESTIONS.exporter)
  }
}
